import { TableBody } from '@mui/material';

import Table from './Table';

import TableCell from './TableCell';
import TableHead from './TableHead';
import TableRow from './TableRow';

Table.Cell = TableCell;
Table.Head = TableHead;
Table.Row = TableRow;
Table.Body = TableBody;

export default Table;
